import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/TalkSection.css';

const TalkSection = () => {
  const { t } = useTranslation();
  
  return (
    <section className="talk-section">
      <h2 className="talk-title talk-title-mobile">{t('talk.talkToMe')}</h2>
      <div className="talk-image-container">
        <div className="talk-image" style={{ backgroundImage: 'url(/images/page12.png)' }}>
          <h2 className="talk-title talk-title-desktop">{t('talk.talkToMe')}</h2>
          <div className="talk-header">
            <div className="talk-greeting">{t('talk.hello')}</div>
            <div className="talk-intro">{t('talk.imBobo')}</div>
            <div className="talk-dots">°.....&</div>
          </div>
          <div className="talk-content">
            <p className="talk-subtitle">
              {t('talk.loveTalking')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TalkSection; 